import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'components/ui/button';

export default function EmailEmptyState() {
  const newEmail = () => {};

  return (
    <>
      <svg height="0" width="0">
        <defs>
          <linearGradient
            gradientTransform="rotate(30 .5 .5)"
            gradientUnits="objectBoundingBox"
            id="emailEmptyStateGradient"
          >
            <stop offset="13.34%" stopColor="#2042A7" />
            <stop offset="83.43%" stopColor="#7422CE" />
          </linearGradient>
        </defs>
      </svg>

      <div className="email-empty-state">
        <FontAwesomeIcon className="exclamation-icon" icon={faExclamationCircle} size="6x" />
        <h2>No Emails to Display</h2>
        <Button className="create-email-button" icon={faPlus} onClick={newEmail}>
          New Email
        </Button>
      </div>
    </>
  );
}
